import $ from 'jquery';
import { Datepicker } from 'vanillajs-datepicker';
import ru from 'vanillajs-datepicker/js/i18n/locales/ru.js';
import { checkDateAvailability, convertFromRuLocaleDateList } from '../utils/Date';

Object.assign(Datepicker.locales, ru);

$('.js-inline-datepicker').each((index, element) => {
    const options = JSON.parse(element.dataset.options || '{}');
    new Datepicker(element, {
        language: 'ru',
        minDate: new Date(),
        ...options,
        datesDisabled: function(date, viewId) {
            return (
                !checkDateAvailability(
                    convertFromRuLocaleDateList(options.datesAvailable),
                    convertFromRuLocaleDateList(options.datesDisabled),
                    date
                ) && viewId === 0
            );
        }
    });
});
